import React, {FC} from 'react';

import {Elements} from '@stripe/react-stripe-js';

import {useApplePayStripe} from 'hooks/useApplePayStripe/useApplePayStripe';

import {useShippingProtectionEnabled} from '../../hooks/shippingProtection/useShippingProtectionEnabled';

import {PaymentApplePayConnected} from './paymentApplePay';

/**
 * Payment Apple Pay for checkout
 */
export const PaymentApplePayWrapper: FC = () => {
    const stripe = useApplePayStripe();
    const {price} = useShippingProtectionEnabled();

    if (!stripe) return null;

    return (
        <Elements stripe={stripe}>
            <PaymentApplePayConnected price={price} />
        </Elements>
    );
};
